import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import logo from "../Assets/img/qb.png";
import sana from "../Assets/img/sanaPanel.png";
import black from "../Assets/img/blackPipe.png";
import powerPanel from "../Assets/img/powerPanel.png";
import brc from "../Assets/img/qandelbrc.png";
import smood from "../Assets/img/alsmood.png";
import steel from "../Assets/img/rawsteel.png";


const Brands = () => {
  return (
    <>
      {/* Brands */}
      <Container>
        <Container fluid id="brands">
          <Row>
            <Col className="text-center">
              <Link to="/">
                <img src={logo} className="img-fluid" alt="" />
              </Link>
            </Col>
            <Col className="text-center">
              <Link to="/qandelbrc">
                <img src={brc} className="img-fluid" alt="" loading="eager"/>
              </Link>
            </Col>
            <Col className="text-center">
              <Link to="/blackpipe">
                <img src={black} className="img-fluid" alt="" />
              </Link>
            </Col>
            <Col className="text-center">
              <Link to="/alsmood">
                <img src={smood} className="img-fluid" alt="" />
              </Link>
            </Col>
            <Col className="text-center">
              <Link to="/powerpanel">
                <img src={powerPanel} className="img-fluid " alt="" />
              </Link>
            </Col>
           <Col className="text-center d-flex align-items-center justify-content-center">
  <Link to="/sanapanel">
    <img 
      src={sana} 
      className="img-fluid sana-logo-custom" 
      alt="Sana Panel Logo"
      loading="eager" 
    />
  </Link>
</Col>
<Col className="text-center d-flex align-items-center justify-content-center">
              <Link to="/rawsteel">
                <img src={steel} className="img-fluid sana-logo-custom " alt="" />
              </Link>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default Brands;
